/**
 * Get the currency symbol for a given currency code and locale.
 */
export function getCurrencySymbol(currencyCode, locale) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode
  }).formatToParts(0).find(part => part.type === 'currency')?.value || '';
}